interface FormTitleProps {
  title: string;
  className?: string;
}

export default function FormTitle({ title, className = "" }: FormTitleProps) {
  const hasFontSize = className.split(" ").some(c => c.startsWith("text-"));
  const baseClasses = `font-bold text-gray-900 mb-4 ${!hasFontSize ? "text-xl" : ""}`;

  return <h2 className={`${baseClasses} ${className}`}>{title}</h2>;
}
